import { Component, OnInit, OnDestroy, Output, Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import {
    UserContext, BaseComponent, Activity, Task,
    ActivityTypeResponse, ActivityType, TaskResponse,
    ActivityResponse,
    PresenceTimeResponse
} from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { ActivityService } from '../service/activity.service';
import { TaskService } from '../service/task.service';
import { AppConstants } from '../core/app.constants';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { PresenzeService } from 'app/service/presenze.service';

declare var $: any;

@Component({
    selector: 'app-detail-activity',
    templateUrl: './detail-activity.component.html',
    styleUrls: ['./detail-activity.component.css'],
    host: { '(window:keydown)': 'shortcutHandler($event)' },
})
export class DetailActivityComponent extends BaseComponent implements OnInit, OnDestroy {
    static DIALOG_ID: string = "detailActivityDialog";

    title: string = "";
    mode: string = ""; // I = insert, U=update
    isOpened: boolean = false;
    successMessage: string = null;
    @Output() completeAction = new EventEmitter<number>();
    @Output() enableOpenDetail = new EventEmitter<boolean>();
    userContext: UserContext = null
    it: any = AppConstants.ITA_CALENDAR_CONF;
    activity: Activity = null;
    errorMessage: string;
    activityDate: Date = null;
    activityHours: number = 0;
    activityMinutes: number = 0;
    activityDuration: string = "";
    activityDescription: string = null;
    activityType: SelectItem;
    taskId: number = 0;
    taskSelected: Task = null;
    createdTask: Subject<number> = new Subject<number>();
    completed: boolean = true;
    hours: SelectItem[] = [];
    minutes: SelectItem[] = [];
    types: SelectItem[] = [];
    tasks: Task[] = [];
    loading: boolean = false;
    lastActivity: Activity = null;
    userInsertDate :boolean=false;

    private resetTaskSelected = new Subject<any>();
    private subscriptions: Subscription[] = [];

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private activityService: ActivityService,
        private presenzeService: PresenzeService,
        private taskService: TaskService) {
        super(authAccess, router, messageProvider);
        for (let i = 0; i <= 24; ++i) {
            this.hours.push({ label: i + "", value: i });
        }
        for (let i = 0; i <= 45; i += 15) {
            this.minutes.push({ label: i + "", value: i });
        }
    }


    ngOnDestroy() {
        if (this.subscriptions != null) {
            for (let i = 0; i < this.subscriptions.length; ++i) {
                this.subscriptions[i].unsubscribe();
            }
        }
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();
        if (this.userContext == null) {
            this.authAccess.invalidate();
        } else {
            this.initActivityTypes();
            this.activityService.getActivityDetailStatus().subscribe(
                activity => {
                    if (activity != null) {

                        this.title = (activity.id == null ? "Inserimento " : "Modifica ") + "Attività";
                        this.mode = activity.id == null ? "I" : "U";
                        this.errorMessage = null;
                        this.successMessage = null;
                        this.activity = activity;
                        if (activity.isForNewTask) {
                            this.loadTask();
                        }
                        this.initialize(true);
                        $("#" + DetailActivityComponent.DIALOG_ID).modal({ backdrop: 'static', keyboard: false }).
                            on("shown.bs.modal", function (e) {
                                $("#activityDurationFieldID").focus();
                            });
                        this.isOpened = true;
                    } else {
                        this.close();
                    }
                }
            );

            this.loadTask();

            this.subscriptions[0] = this.taskService.getCreationTaskEvent().subscribe(
                taskId => {
                    if (taskId > 0 && this.isOpened == true) {
                        this.taskId = taskId;
                        this.createdTask.next(taskId);
                    }
                }
            );

            this.subscriptions[1] = this.taskService.getRefreshTasksEvent().subscribe(
                tasks => {
                    this.tasks = tasks;
                }
            );
        }
    }

    private loadTask() {
        let obsRecents: Observable<TaskResponse> = this.taskService.getRecentTasks(this.userContext.srmToken, 0);
        let obsSearch: Observable<TaskResponse> = this.taskService.searchTask(this.userContext.srmToken, "", 0);
        this.tasks = [];
        Observable.forkJoin([obsRecents, obsSearch]).subscribe(
            results => {
                let responseRecent: TaskResponse = results[0];
                for (var i = 0; i < responseRecent.issues.length; ++i) {
                    this.addTasksWidhType(responseRecent.issues, "glyphicon-time");
                }
                let responseSearch: TaskResponse = results[1];
                for (var i = 0; i < responseSearch.issues.length; ++i) {
                    this.addTasksWidhType(responseSearch.issues, "glyphicon-tags");
                }
            },
            error => {
                this.handleError(error);
            }
        );
    }

    private addTasksWidhType(tasks: Task[], tipo: string) {
        if (tasks.length == 0) {
            return;
        }
        for (let i = 0; i < tasks.length; ++i) {
            tasks[i].listItemIcon = tipo;
        }
        this.tasks = this.tasks.concat(tasks);
    }

    setSelectedTask(tasks: Task[]) {
        if (tasks != null && tasks.length != 0) {
            this.taskSelected = tasks[0];
        } else {
            this.taskSelected = null;
        }
    }

    storeActivity(closeOnComplete: boolean) {
        if (this.activityDate == null) {
            this.setErrorMessage("Indicare la data Dell'attivit&agrave");
            return;
        }
        if (this.activity.id == null) {
            this.insertActivity(closeOnComplete);
        } else {
            this.updateActivity();
        }
    }

    checkActivityDuration(completed:boolean) {
        if (this.activityDuration == null || this.activityDuration.trim() == "") {
            this.activityHours = 0;
            this.activityMinutes = 0;
            return;
        }
        let index = this.activityDuration.lastIndexOf(":");
        if (index > 0) {
            let tmp: string[] = this.activityDuration.split(":");
            let hh = Number(tmp[0]);
            let mm = Number(tmp[1]);

            if (hh > 23 || mm > 59) {
                this.activityDuration = null;
                this.activityHours = 0;
                this.activityMinutes = 0;
            } else {
                this.activityHours = hh;
                this.activityMinutes = mm;
                if(completed){
                this.userInsertDate=true;}
            }
        }
    }

    private insertActivity(closeOnComplete: boolean) {
        if (!this.validateInput()) {
            return;
        }
        this.completed = false;
        this.activityService.createActivity(this.userContext.srmToken,
            this.taskSelected.id, this.activityDate, this.activityHours,
            this.activityMinutes, Number(this.activityType), this.activityDescription).subscribe(
                response => {
                    this.completeAction.emit(0);
                    if (closeOnComplete) {
                        this.close();
                    } else {
                        this.setSuccessMessage("Attività inserita con successo");
                        let diff = (this.activity.spentHours + this.activity.spentMinutes / 60) - (this.activityHours + this.activityMinutes / 60);
                        this.activity.spentHours = Math.floor(diff);
                        this.activity.spentMinutes = (diff - this.activity.spentHours) * 60;
                        this.initialize(false);
                        $("#activityDurationFieldID").focus();
                    }
                    this.completed = true;
                    this.userInsertDate=false;
                },
                error => {
                    this.completed = true;
                    this.setErrorMessage(this.retrieveError(error));
                });
    }

    private updateActivity() {
        if (!this.validateInput()) {
            return;
        }
        this.completed = false;
        this.activityService.updateActivity(this.userContext.srmToken, this.activity.id, this.taskSelected.id,
            this.activityDate, this.activityHours, this.activityMinutes,
            Number(this.activityType), this.activityDescription).subscribe(
                response => {
                    this.completed = true;
                    if (this.activity.issueId != this.taskSelected.id) {
                        this.activityService.moveActivity(this.userContext.srmToken, this.activity.id, this.taskSelected.id).
                            subscribe(
                                res => {
                                    this.completeAction.emit(0);
                                    this.close();
                                },
                                error => {
                                    this.setErrorMessage(this.retrieveError(error));
                                });
                    }
                    else {
                        this.completeAction.emit(0);
                        this.close();
                    }
                },
                error => {
                    this.completed = true;
                    this.setErrorMessage(this.retrieveError(error));
                });
    }


    private validateInput(): boolean {
        if (this.activityDate == null) {
            this.setErrorMessage("Indicare la data dell'attività");
            return false;
        }
        if (this.activityHours == 0 && this.activityMinutes == 0) {
            this.setErrorMessage("Indicare la durata dell'attività");
            return false;
        }
        if (this.activityMinutes % 15 != 0) {
            this.setErrorMessage("Indicare una durata arrotondata a 15 min");
            return false;
        }

        if (this.activityType.value == 0) {
            this.setErrorMessage("Indicare il tipo di attività");
            return false;
        }

        if (this.taskSelected == null) {
            this.setErrorMessage("Indicare il task su cui si è stata svolta l'attività");
            return false;
        }
        if (this.activityDescription == null || this.activityDescription.trim() == "") {
            this.setErrorMessage("Inserire la descrizione dell'attività svolta");
            return false;
        }
        return true;
    }

    private initActivityTypes() {
        var response: ActivityTypeResponse;
        this.activityService.getAcivityTypes(this.userContext.srmToken).subscribe(
            result => {
                response = result;
                var types = response.activityTypes;
                for (var i = 0; i < types.length; ++i) {
                    var current: ActivityType = types[i];
                    this.types.push({ label: current.name, value: current.id });
                }
            },
            error => {
                this.handleError(error);
                this.close();
            });
    }

    close() {
        $("#" + DetailActivityComponent.DIALOG_ID).modal("hide");
        this.enableOpenDetail.emit(true);
        this.isOpened = false;
        this.activity = null;
        this.errorMessage = null;
        this.setSelectedTask(null);
        this.userInsertDate=false;
    }

    private initialize(isNewDate: boolean) {
        if (isNewDate) {
            this.activityDate = this.activity.id == null ? new Date() : new Date(this.activity.inserted);
        }
        this.activityHours = this.activity.spentHours == null ? 0 : this.activity.spentHours;
        this.activityMinutes = this.activity.spentMinutes == null ? 0 : this.activity.spentMinutes;

        this.activityDuration = this.activityHours < 10 ? "0" + this.activityHours : this.activityHours + "";
        this.activityDuration += ":";
        this.activityDuration += this.activityMinutes < 10 ? "0" + this.activityMinutes : this.activityMinutes + "";

        this.activityDescription = this.activity.id == null ? "" : this.activity.comment;
        this.activityType = this.activity.activityTypeId == null ? this.types[0].value : this.activity.activityTypeId;
        this.taskId = this.activity.issueId == null ? 0 : this.activity.issueId;
        if (this.taskId == 0) {
            this.resetTaskSelected.next(null);
            this.taskSelected = null;
        }
    }

    private setErrorMessage(errMsg) {
        this.errorMessage = errMsg;
        this.successMessage = null;
    }

    private setSuccessMessage(successMsg) {
        this.successMessage = successMsg;
        this.errorMessage = null;
    }

    shortcutHandler(event) {
        if (this.isOpened == false) { return; }
        if (event.keyCode == 113) { // F2
            this.storeActivity(true);
        } else if (event.keyCode == 27) { // ESC
            this.close();
        }
    }

    calculateActivityTime() {
        if(this.mode=="I" && !this.userInsertDate){
        this.loading = true;
        this.completed = false;
        this.presenzeService.timeworked(this.userContext.srmToken, this.activityDate, null).subscribe(
            (timeworked) => {
                this.activityService.search(this.userContext.srmToken, this.activityDate, this.activityDate, null, null).subscribe(
                    (activity) => {
                        this.activityDuration = this.calcoloDiff(activity, timeworked);
                        this.loading = false;
                        this.completed = true;
                    })
            },
            (error) => {
                this.handleError(error);
                this.loading = false;
                this.completed = true;
            }
        );
    }}

    calcoloDiff(attivita: ActivityResponse, presenza: PresenceTimeResponse): string {
        const minutiA = attivita.totalHours * 60 + attivita.totalMinutes;
        const minutiB = presenza.hoursValued * 60 + presenza.minutesValued;
        let diff = minutiA - minutiB;
        if (diff < 0) {
            diff = -diff;
        }
        this.activity.spentHours = Math.floor(diff / 60);
        this.activity.spentMinutes = diff % 60;
        const oreStr = this.activity.spentHours < 10 ? "0" + this.activity.spentHours : "" + this.activity.spentHours;
        const minutiStr = this.activity.spentMinutes < 10 ? "0" + this.activity.spentMinutes : "" + this.activity.spentMinutes;
        this.activityMinutes = this.activity.spentMinutes;
        this.activityHours = this.activity.spentHours;
        return `${oreStr}:${minutiStr}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/detail-activity/detail-activity.component.ts